// import React from 'react';

// // Chart title with a "View details" link on the right
// export const ChartTitle = ({ children, onClick, hint = 'View details' }) => (
//   <div className="d-flex justify-content-between align-items-center mb-3">
//     <h5 className="f-16 bold mb-0">{children}</h5>
//     {/* {onClick && (
//       <button
//         type="button"
//         className="btn btn-link p-0 f-12"
//         style={{ textDecoration: 'none' }}
//         onClick={onClick}
//       >
//         {hint} <i className="ri-arrow-right-line" />
//       </button>
//     )} */}

//     <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M7 17L17 7"/>
//     <path d="M7 7h10v10"/>
// </svg>



// {/* <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//   <path d="M9 18l6-6-6-6"/>
// </svg> */}

//   </div>
// );

// // Makes the chart bars/points clickable (pointer cursor + click action)
// export const withChartNavigation = (options, onNavigate) => {
//   if (!options) return options;
//   const series = options.plotOptions?.series || {};
//   return {
//     ...options,
//     plotOptions: {
//       ...(options.plotOptions || {}),
//       series: {
//         ...series,
//         cursor: 'pointer',
//         point: {
//           ...(series.point || {}),
//           events: { ...(series.point?.events || {}),
          
//         //   click: onNavigate

//         // click: function () {
//         //     console.log('[chart click]', this.category, this.series?.name);
//         //       onNavigate({
//         //         category: this.category,
//         //         seriesName: this.series?.name,
//         //         x: this.x,
//         //         y: this.y,
//         //       });

//         click: function (event) {
//               console.log('🔥 HIGHCHART CLICK WORKING');
//               console.log('category:', this.category);
//               console.log('series:', this.series?.name);
//               console.log('x:', this.x);
//               console.log('y:', this.y);
//               console.log('point:', this);


//               console.log('category:', this.category);
//   console.log('weekNumberFromCategory result:', weekNumberFromCategory(this.category));

//               onNavigate({
//                 category: this.category,
//                 seriesName: this.series?.name,
//                 x: this.x,
//                 y: this.y,
//               });

//             },

//          },
//         },
//       },
//     },
//   };
// };




// // "Week 47" / "Week #47" -> 47. Anything else (dates, milestones) -> null
// export const weekNumberFromCategory = (category) => {
// // 
// console.log("Weekly category",category)

// // return category
//   const m = /^\s*week\s*#?\s*(\d+)\s*$/i.exec(String(category ?? ''));

//   console.log("Weekly category",m)
//   return m ? Number(m[1]) : null;
// };



import React from 'react';

// Chart title with a "View details" link on the right
export const ChartTitle = ({ children, onClick, hint = 'View details' }) => (
  <div className="d-flex justify-content-between align-items-center mb-3">
    <h5 className="f-16 bold mb-0">{children}</h5>
    {/* {onClick && (
      <button
        type="button"
        className="btn btn-link p-0 f-12"
        style={{ textDecoration: 'none' }}
        onClick={onClick}
      >
        {hint} <i className="ri-arrow-right-line" />
      </button>
    )} */}

    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M7 17L17 7"/>
    <path d="M7 7h10v10"/>
</svg>



{/* <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <path d="M9 18l6-6-6-6"/>
</svg> */}

  </div>
);

// Makes the chart bars/points clickable (pointer cursor + click action)
// and visually "fills"/highlights whichever point was last clicked.
export const withChartNavigation = (
  options,
  onNavigate,
  selectedColor = '#1c1c1c',
) => {
  if (!options) return options;
  const series = options.plotOptions?.series || {};
  return {
    ...options,
    plotOptions: {
      ...(options.plotOptions || {}),
      series: {
        ...series,
        cursor: 'pointer',
        allowPointSelect: true, // required for Highcharts to track a "selected" point at all
        states: {
          ...(series.states || {}),
          select: {
            // this is the actual "fill" applied to the clicked/selected point
            color: selectedColor,
            ...(series.states?.select || {}),
          },
        },
        point: {
          ...(series.point || {}),
          events: {
            ...(series.point?.events || {}),
            click: function (event) {
              // Highcharts only applies the select-state fill once a point is
              // actually marked selected — this is what was missing before.
              this.select(true, false);

              onNavigate({
                category: this.category,
                seriesName: this.series?.name,
                x: this.x,
                y: this.y,
              });
            },
          },
        },
      },
    },
  };
};




// "Week 47" / "Week #47" -> 47. Anything else (dates, milestones) -> null
export const weekNumberFromCategory = (category ) => {
// 
console.log("Weekly category",category)



return category
// return category
//   const m = /^\s*week\s*#?\s*(\d+)\s*$/i.exec(String(category ?? ''));

//   console.log("Weekly category",m)
//   return m ? Number(m[1]) : null;
};





